<template>
  <div
    id="task_container_list"
    class="box relative mx-5 flex h-full min-h-0 flex-col"
  >
    <slot name="before_header" />
    <div
      class="sticky right-0 left-0 flex justify-between border-b bg-white/90 py-3 dark:bg-slate-700/90"
      :class="[stickyTop]"
    >
      <div class="flex justify-center gap-x-3">
        <div class="flex items-center gap-x-3">
          <FontAwesomeIcon v-if="icon" :icon="['fal', icon]" size="xl" />
          <h2 class="capitalize-first text-2xl font-bold">{{ title }}</h2>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="flex gap-x-3" :class="ctaClass">
          <slot name="cta" />
        </div>
      </div>
    </div>
    <div
      id="list_container_items"
      class="flex-1 overflow-y-auto bg-white py-3 dark:bg-slate-700"
    >
      <slot />
    </div>
    <div
      v-if="$slots.bottom"
      class="sticky right-0 bottom-0 left-0 z-10 flex justify-end gap-x-3 border-t bg-white/90 p-3 dark:bg-slate-700/90"
    >
      <slot name="bottom" />
      <!--#endregion -->
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseFixedBarCard',
  components: { FontAwesomeIcon },
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    ctaClass: {
      type: String,
      required: false,
      default: ''
    },
    stickyTop: {
      type: String,
      required: false,
      default: 'top-0'
    }
  }
}
</script>
